import { translateContent } from "utils/localisation";

export default function(text) {
  return translateContent(text);
}
